import { Injectable } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { EnableLoadingIndicator } from '../../../shared/loading-indicator';

@Injectable({
    providedIn: 'root'
})
export class RPackageService {

    constructor(private http: HttpClient) { }

    getRCallsObjects(packageId) {
        return this.http.get<RCallDto[]>('/bmsapi/r-packages/' + +packageId + '/r-calls');
    };

    executeRCall(url, parameters) {
        return this.http.post(url, new URLSearchParams(parameters).toString(), {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            responseType: 'text', observe: 'response',
            context: new HttpContext().set(EnableLoadingIndicator, true)
        });
    };
}


export class RCallDto {
    rCallId: number;
    description: string;
    endpoint: string;
    parameters: Map<string, string>;
    isAggregate : boolean;
}
